import { render, staticRenderFns } from "./LocalTradingview.html?vue&type=template&id=a27221ca&scoped=true&"
import script from "./LocalTradingview.js?vue&type=script&lang=js&"
export * from "./LocalTradingview.js?vue&type=script&lang=js&"
import style0 from "./LocalTradingview.scss?vue&type=style&index=0&id=a27221ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27221ca",
  null
  
)

export default component.exports